import { Counter } from '@natu/ui/Counter';
import { Typography } from '@natu/ui/Typography';

import { type SBProps, sbEditable } from '../../../../utils';

interface SBCounterProps {
  number?: string;
  text?: string;
  from?: string;
  animationDuration?: string;
}

export const SBCounter = ({ blok }: SBProps<SBCounterProps>) => {
  const { number = '0', text, from = '0', animationDuration = '600' } = blok;

  if (!number) return null;

  const counterProps = {
    from: parseInt(from, 10),
    to: parseInt(number, 10),
    duration: parseInt(animationDuration, 10) / 1000,
  };

  return (
    <Typography
      className="text-primary-600 text-center font-semibold"
      variant={['display-lg', 'display-lg', 'display-xl']}
      {...sbEditable(blok)}
    >
      <Counter {...counterProps} />
      {text}
    </Typography>
  );
};
